// extracted by mini-css-extract-plugin
export var cardView = "ProductCard-module--card-view--d7e2e";
export var icon = "ProductCard-module--icon--9048d";
export var img_wrapper = "ProductCard-module--img_wrapper--a0b7e";
export var mainImg = "ProductCard-module--mainImg--7475a";
export var triangle_wrapper = "ProductCard-module--triangle_wrapper--d481f";